/* global axios */

import PortalsAPI from './portals';

class DictionaryEntriesAPI extends PortalsAPI {
  constructor() {
    super('translation_dictionary_entries', { accountScoped: true });
  }

  get({ portalSlug }) {
    return axios.get(
      `${this.url}/${portalSlug}/translation_dictionary_entries`
    );
  }

  create({ portalSlug, entryObj }) {
    return axios.post(
      `${this.url}/${portalSlug}/translation_dictionary_entries`,
      entryObj
    );
  }

  update({ portalSlug, entryId, entryObj }) {
    return axios.patch(
      `${this.url}/${portalSlug}/translation_dictionary_entries/${entryId}`,
      entryObj
    );
  }

  delete({ portalSlug, entryId }) {
    return axios.delete(
      `${this.url}/${portalSlug}/translation_dictionary_entries/${entryId}`
    );
  }

  translate({ portalSlug, term }) {
    return axios.post(
      `${this.url}/${portalSlug}/translation_dictionary_entries/translate`,
      { term }
    );
  }
}

export default new DictionaryEntriesAPI();
